import { patch } from '..';

const updateTicketUserGroups = (ticketId: string, userGroupIds: string[]) => patch(`assets/tickets/${ticketId}`, {
  userGroupIds,
});

export default updateTicketUserGroups;
